<template>
  <v-card>
    <v-layout row justify-center>
      <div
        v-if="messageQueue"
        class="box-message-queue"
        style="color: #1976d2 !important; caret-color: #1976d2 !important"
      >
        <v-img
          :src="getHeartEyes"
          height="24"
          width="24"
          max-width="24"
          class="mr-2 mb-1"
        ></v-img>
        <b
          class="mr-1"
          style="color: #1976d2 !important; caret-color: #1976d2 !important"
          >Sua vez chegou!</b
        >
        Escolha os ingressos...
      </div>
    </v-layout>
    <v-card-title>
      <v-layout justify-space-between row>
        <h2 class="checkout-h2">Ingressos</h2>
        <span
          v-if="
            (products && !showCode && !hasCupom) ||
              isCupomTracking ||
              isScheduledCampaign
          "
          class="secondary--text link"
          @click="setShowCode"
          >Aplicar um código</span
        >
      </v-layout>
    </v-card-title>
    <v-container
      v-if="
        (showCode && !isCupomTracking) ||
          (hasCupom && !isCupomTracking) ||
          (showCode && isScheduledCampaign)
      "
      grid-list-xs
      :class="
        isScheduledCampaign && !cupomData.campaign_description && !showCode
          ? 'pa-0 ma-0'
          : ''
      "
    >
      <v-layout row wrap justify-space-between v-if="products && showCode">
        <v-text-field
          outline
          label="Escreve seu código aqui"
          ref="cupomId"
          v-model="cupomCode"
          @keyup.enter="applyCode"
        ></v-text-field>
        <v-btn
          large
          depressed
          class="normal-text cst-btn"
          :class="{ 'btn-disabled': !cupomCode }"
          :color="!!cupomCode ? 'primary' : 'info'"
          @click="applyCode"
          dark
        >
          Aplicar
        </v-btn>
      </v-layout>

      <v-layout row wrap v-if="hasCupom">
        <v-layout
          v-if="isValidCupomCode && !loading"
          row
          justify-space-between
          align-center
          :class="
            isScheduledCampaign && !cupomData.campaign_description
              ? 'transparent-background'
              : 'success-background'
          "
        >
          <v-layout column>
            <v-layout row>
              <span
                style="width: 100%; border-radius: 4px; padding: 8px;"
                class="success-text-code"
                v-if="cupomData && !isScheduledCampaign"
              >
                {{ isCupomCard ? 'Cartão' : 'Código' }}
                <strong class="success-text-code">{{ cupomCode }}</strong>
                {{ isCupomCard ? 'válido!' : 'aplicado!' }}
              </span>
            </v-layout>
            <v-layout row>
              <span
                style="width: 100%; border-radius: 4px; padding: 8px;"
                class="custom-html"
                v-html="cupomData.campaign_description"
              ></span>
            </v-layout>
          </v-layout>

          <v-btn
            v-if="!isScheduledCampaign"
            right
            flat
            icon
            color="green"
            class="mr-0"
            @click="removeCode"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout
          v-else-if="!loading"
          row
          justify-space-between
          align-center
          class="red"
        >
          <span
            v-if="!isCupomCard"
            style="width: 100%; border-radius: 4px; padding: 8px;"
            class="white--text"
          >
            <v-icon class="white--text" left>warning</v-icon>
            <span v-if="!cupomMessage" class="white--text"
              >Código
              <strong class="white--text">{{ cupomCode }}</strong> inválido ou
              esgotado.</span
            >
            <span v-else class="white--text">{{ cupomMessage }}</span>
          </span>
          <span
            v-else
            style="width: 100%; border-radius: 4px; padding: 8px;"
            class="white--text"
          >
            <v-icon class="white--text" left>warning</v-icon>
            Cartão inválido para a promoção
          </span>
          <v-btn right flat icon color="white" class="mr-0" @click="removeCode">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-layout>
    </v-container>
    <products-panel />
    <div
      v-if="
        eventDetails &&
          eventDetails.campanha_cartao &&
          !cupomCodeSetted &&
          $route.name !== 'totem'
      "
    >
      <v-divider></v-divider>
      <v-expansion-panel>
        <v-expansion-panel-content class="product-expansion-panel">
          <div slot="header" class="panel-header">
            <b class="checkout-h3 title-group">{{
              eventDetails.campanha_cartao.nome
            }}</b>
          </div>
          <v-card class="pa-4">
            <v-text-field
              v-model="cupomCode"
              outline
              label="Insira os 6 primeiros dígitos do seu cartão de crédito"
            ></v-text-field>
            <v-layout justify-center>
              <v-btn
                @click="applyCodeCard"
                round
                color="primary"
                depressed
                style="text-transform: none"
                >Aplicar</v-btn
              >
            </v-layout>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-card>
</template>

<script>
import ProductsPanel from './ProductsPanel';
import heartEyes from '../../assets/heart-eyes.png';
import { mapGetters } from 'vuex';
import { incrementStringInSrc } from '../../utils/facebook-pixel';
import { cupomData } from '../../store/modules/products/getters';

export default {
  components: { ProductsPanel },
  props: ['products', 'sectors'],
  data() {
    return {
      showCode: false,
      code: '',
      open: false,
      cupomCard: false,
    };
  },
  computed: {
    ...mapGetters({
      loading: 'loading',
      isCupomCard: 'isCupomCard',
      cupomMessage: 'cupomMessage',
      htBySite: 'htBySite',
      store: 'store',
      totalAmount: 'totalAmount',
      body: 'body',
      hasProductsCart: 'hasProductsCart',
      cupomData: 'cupomData',
    }),
    cupomCode: {
      get() {
        return this.$store.getters.cupomCode;
      },
      set(value) {
        this.$store.dispatch('setCupomCode', value);
      },
    },
    getHeartEyes() {
      return heartEyes;
    },
    urlCupom() {
      return this.$store.getters.urlCupom;
    },
    eventDetails() {
      return this.$store.getters.eventDetails;
    },
    messageQueue() {
      return this.$store.getters.messageQueue;
    },
    isValidCupomCode() {
      return this.$store.getters.isValidCupomCode;
    },
    isCupomTracking() {
      return this.$store.getters.isCupomTracking;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    hasCupom() {
      return this.$store.getters.hasCupom;
    },
    noSectorProducts() {
      return this.$store.getters.noSectorProducts;
    },
    currentStep() {
      return this.$store.getters.currentStep;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    facebookPixel() {
      return this.$store.getters.facebookPixel;
    },
    cupomCodeSetted() {
      if (localStorage.getItem(`cupomCodeEvent-${this.eventID}`)) return true;
      else return false;
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            somador += (v.valor + v.valor_conveniencia) * v.quantidade;
          });
        });
        total = somador;
      }
      return total;
    },

    totalWithoutTax() {
      let total = 0;
      let somador = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            somador += v.valor * v.quantidade;
          });
        });
        total = somador;
      }
      return total;
    },

    isScheduledCampaign() {
      return this.cupomData.campaign_type === 'programada';
    },
  },
  methods: {
    setShowCode() {
      this.showCode = !this.showCode;
      if (this.isCupomTracking) {
        this.$store.commit('SET_IS_CUPOM_TRACKING', false);
        this.$store.commit('SET_HAS_CUPOM', false);
        this.cupomCode = null;
        this.showCode = true;
      }
      if (this.showCode && !this.hasCupom) {
        setTimeout(this.setFocus, 200);
      }
    },
    setFocus() {
      this.$refs.cupomId.focus();
    },
    applyCode() {
      this.$store.commit('SET_CUPOM_CARD', false);
      if (this.cupomCode) {
        this.$store.dispatch('setSectorsList');
        localStorage.setItem('cupomCode', this.cupomCode);
        localStorage.setItem(`cupomCodeEvent-${this.eventID}`, this.cupomCode);
        localStorage.setItem('cupomCodeEvent', this.eventID);
      }
    },
    applyCodeCard() {
      this.$store.commit('SET_CUPOM_CARD', true);
      if (this.cupomCode) {
        this.$store.dispatch('setSectorsList');
        localStorage.setItem('cupomCode', this.cupomCode);
        localStorage.setItem(`cupomCodeEvent-${this.eventID}`, this.cupomCode);
        localStorage.setItem('cupomCodeEvent', this.eventID);
      }
    },
    applyUrlCode() {
      this.showCode = true;
      this.cupomCode = this.$store.getters.urlCupom;
      this.$store.dispatch('setUrlCupom', null);
      this.applyCode();
    },
    removeCode() {
      this.$store.commit('SET_COUPON_PRE_SALE', null);
      this.$store.commit('SET_VALIDATED_PRE_SALE', false);
      this.$store.commit('SET_CUPOM_CARD', false);
      localStorage.removeItem(`cupomCodeEvent-${this.eventID}`);
      this.cupomCode = '';
      localStorage.setItem('cupomCode', this.cupomCode);
      localStorage.setItem('cupomCodeEvent', null);
      this.$store.dispatch('setSectorsList');
      this.$store.commit('SET_IS_CUPOM_TRACKING', false);
    },

    async addFacebookPixel() {
      let metaPixelStore =
        this.store && this.store.configs && this.store.configs.metaPixel
          ? this.store.configs.metaPixel
          : null;

      if (this.facebookPixel) {
        const facebookIntegrations = this.eventDetails.integracoes_publicas.filter(
          integration => integration.tipo === 'facebook_pixel'
        );

        facebookIntegrations.forEach(integration => {
          var addToCart = document.createElement('img');
          addToCart.src = `https://www.facebook.com/tr?id=${
            integration.credenciais.token
          }&ev=AddToCart&eid=${this.body.codigo_evento}-${
            this.body.codigo_pedido
          }&cd[currency]=BRL&cd[value]=${
            this.totalWithoutTax
          }&cd[content_type]=product&cd[eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}`;

          addToCart.src += `&cd[contents][0][id]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][quantity]=1`;

          addToCart.src = incrementStringInSrc(
            this.cartProducts,
            addToCart.src
          );

          addToCart.style = 'display:none;';
          addToCart.height = 1;
          addToCart.width = 1;
          document.getElementsByTagName('head')[0].appendChild(addToCart);
        });
      }

      if (metaPixelStore) {
        var addToCart = document.createElement('img');
        addToCart.src = `https://www.facebook.com/tr?id=${metaPixelStore}&ev=AddToCart&eid=${this.body.codigo_evento}-${this.body.codigo_pedido}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

        addToCart.src += `&cd[contents][0][id]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][quantity]=1`;

        addToCart.src = await incrementStringInSrc(
          this.cartProducts,
          addToCart.src
        );

        addToCart.style = 'display:none;';
        addToCart.height = 1;
        addToCart.width = 1;
        document.getElementsByTagName('head')[0].appendChild(addToCart);
      }
    },
  },

  async mounted() {
    const uuidv1 = require('uuid/v1');
    const htsetted = localStorage.getItem('ht');
    if (!htsetted) localStorage.setItem('ht', uuidv1().substring(0, 6));
    const ht = localStorage.getItem('ht');
    let referer = null;
    if (
      this.$store.getters.refererNatal &&
      this.$store.getters.refererNatal !== 'none'
    ) {
      let storage = this.$store.getters.refererNatal;
      referer = storage.split(' - ')[0];
    }
    if (
      ((typeof document.referrer === 'string' &&
        !document.referrer.includes('blueticket')) ||
        this.$store.getters.refererNatal) &&
      !this.htBySite
    )
      this.$store.dispatch('handleAnalytics', {
        event: this.eventID,
        url: document.URL,
        ht: ht,
        device: window.navigator.userAgent,
        referer:
          referer && referer !== 'https://site.blueticket.com.br/natal-luz'
            ? referer
            : this.$store.getters.refererNatal
            ? ''
            : document.referrer,
      });
    if (this.$store.getters.urlCupom) this.applyUrlCode();
    let checkTicketUrl = await localStorage.getItem('checkTicketUrl');
    if (!checkTicketUrl) localStorage.setItem('checkTicketUrl', true);
    if (
      !new URL(window.location).searchParams.get('produto') &&
      !new URL(window.location).searchParams.get('tipo')
    ) {
      localStorage.removeItem('checkTicketUrl');
    }
    if (
      new URL(window.location).searchParams.get('produto') &&
      new URL(window.location).searchParams.get('tipo') &&
      !checkTicketUrl
    ) {
      let type = Number(new URL(window.location).searchParams.get('tipo'));
      let product = Number(
        new URL(window.location).searchParams.get('produto')
      );
      let productSelected = this.noSectorProducts
        ? this.noSectorProducts[0].products.find(p => {
            return p.codigo_produto === product && p.codigo_tipo === type;
          })
        : null;
      if (productSelected) {
        await this.$store.dispatch('addCartProduct', productSelected);
        await this.$store.dispatch(
          'incrementProductsQuantity',
          productSelected
        );
      }
      this.$store.dispatch('setCreationCart', this.cartProducts);

      this.addFacebookPixel();
    }
  },

  watch: {
    showCode(v) {
      if (v) {
        this.cupomCode = '';
      }
    },
  },
};
</script>

<style scoped>
.link {
  cursor: pointer;
}

.cst-btn {
  height: 56px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.success-background {
  background-color: rgba(0, 166, 90, 0.08);
}
.transparent-background {
  background-color: transparent;
}

.success-text-code {
  color: #00a65a;
}
.box-message-queue {
  margin: 20px 0px;
  padding: 0px 15px;
  width: 343px;
  height: 63px;
  background: #1976d244;
  border-radius: 9px;
  display: flex;
  justify-content: start;
  align-items: center;
}
</style>

<style>
.custom-html * {
  color: #00a65a !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
